<div class="pessoa-contato">
    <sgt-accordion [settings]="{ isCollapsed: true, expanded: false }">
        <h6 header class="m-0"><i class="fas fa-phone"></i> {{title}}</h6>

        <!-- Table -->
        <div class="pessoa-contato__table" *ngIf="!isFormOpen">
            <sgt-pessoa-contato-table
                #table
                [canEdit]="canEdit"
                [idTable]="idTable"
                [entities]="entities"
                (edit)="edit($event)"
                (delete)="delete($event)"
                (ativar)="ativar($event)"
                (inativar)="inativar($event)">
            </sgt-pessoa-contato-table>
    
            <div class="pessoa-contato__table__header">
                <sgt-pessoa-contato-dropdown-insert
                    *ngIf="canEdit"
                    [dropup]="entities?.length > 8"
                    (insert)="insert($event)">
                </sgt-pessoa-contato-dropdown-insert>
                
                <span class="quantidade-contatos">
                    {{entities?.length}} contato(s)
                </span>
            </div>      
        </div>
    
        <!-- Form -->
        <ng-template [ngIf]="isFormOpen">
            <h6 *ngIf="!isFormEdit">
                Novo Contato {{form.entity?.tipo | pessoaContatoTipo}}
            </h6>
            <h6  *ngIf="isFormEdit">
                Editando Contato {{form.entity?.tipo | pessoaContatoTipo}}
            </h6>            
    
            <sgt-pessoa-contato-form
                #form
                [canEdit]="canEdit">
            </sgt-pessoa-contato-form>
      
            <div class="">
                <button type="button" class="btn btn-link btn-link-success" id="btnSaveContato" (click)="save()" *ngIf="canEdit">
                    <i class="fas fa-check" aria-hidden="true"></i> Salvar
                </button>
                <button type="button" class="btn btn-link btn-link-light" (click)="cancel()">
                    <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
                </button>
            </div>        
        </ng-template>    
    </sgt-accordion>
</div>
